import React from 'react'
import Moment from 'react-moment'
import { Timespan } from '../../store/events/interfaces'

export const EventTimeSpan = (props: { timespan: Timespan }) => {
  const { timespan } = props
  if (timespan.start.split('T')[0] === timespan.end.split('T')[0])
    // timespans on same day
    return timespan.hide_hours ? (
      <>
        <Moment format='DD.MM.YYYY'>{timespan.start}</Moment>
      </>
      ) : (
      <>
        <Moment format='DD.MM.YYYY HH:mm'>{timespan.start}</Moment> -{' '}
        <Moment format='HH:mm'>{timespan.end}</Moment>
      </>
    )
  else
    // timespans on different days
    return timespan.hide_hours ? (
      <>
        <Moment format='DD.MM.YYYY'>{timespan.start}</Moment> -{' '}
        <Moment format='DD.MM.YYYY'>{timespan.end}</Moment>
      </>
    ) : (
      <>
        <Moment format='DD.MM.YYYY HH:mm'>{timespan.start}</Moment> -{' '}
        <Moment format='DD.MM.YYYY HH:mm'>{timespan.end}</Moment>
      </>
    )
}
